// Admin walkthrough: Rules page -> Categories page. Each step highlights one
// element (by CSS selector) on a given route, with a short description.
// `tab` (Categories page only) tells Categories.jsx which of its internal
// Categories/Years/Questions tabs to switch to before this step is shown.
const TOUR_STEPS = [
  {
    route: "/admin/rules",
    selector: ".rules-php-card--left",
    title: "Add custom rules",
    description: "Write the rules players see before they start playing. Click “+ Add new rule” to add up to 6.",
  },
  {
    route: "/admin/rules",
    selector: "#rules-points",
    title: "Points per correct answer",
    description: "Set how many points a player earns for each correct answer.",
  },
  {
    route: "/admin/rules",
    selector: "#rules-tabname",
    title: "Browser tab name",
    description: "Give this game a short name (up to 20 characters) — it shows as the browser tab title everywhere players play.",
  },
  {
    route: "/admin/rules",
    selector: "#rules-button-color",
    title: "Theme colors",
    description: "Pick the button color, button text color, and text color used throughout the game.",
  },
  {
    route: "/admin/rules",
    selector: ".save-and-continue",
    title: "Save & continue",
    description: "Save your rules here, then move on to build your categories.",
  },
  {
    route: "/admin/categories",
    tab: "categories",
    selector: ".categories-page-tabs",
    title: "Categories, Years & Questions",
    description: "Use these tabs to manage your categories, their year milestones, and the questions inside each year.",
  },
  {
    route: "/admin/categories",
    tab: "categories",
    selector: ".categories-add-card",
    title: "Add a category",
    description: "Click here to add a category — up to 6, each with its own name, color, icon, and background images.",
  },
  {
    route: "/admin/categories",
    tab: "categories",
    selector: ".categories-bg-tabs",
    title: "Upload background images",
    description: "Click a category above to upload its desktop & mobile background images. “Others” holds the year marker icon and question background image.",
  },
  {
    route: "/admin/categories",
    tab: "years",
    selector: ".cy-tag-add-row",
    title: "Add year milestones",
    description: "Pick a category above, then add up to 4 year milestones for it — each year needs at least 1 question.",
  },
  {
    route: "/admin/categories",
    tab: "questions",
    selector: ".cy-add-row",
    title: "Add questions",
    description: "Add a question directly, or upload a CSV to add many at once — up to 5 questions per year.",
  },
  {
    route: "/admin/categories",
    tab: "questions",
    selector: ".all-q-filter-hint",
    title: "Filter questions",
    description: "These tabs just filter which questions you see in the list below — a CSV upload still routes each row to the category named in that row, regardless of this filter.",
  },
  {
    route: "/admin/categories",
    tab: "categories",
    selector: ".save-and-continue",
    title: "Save your work",
    description: "Always click Save after making changes here — it publishes everything straight to the live game.",
  },
];

export default TOUR_STEPS;
